import { StudentHomeworkDetailPage } from "@/pages/teacher/StudentHomeworkDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/teacher/classrooms/$classroomId/students/$studentId/homework/$homeworkId"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId, studentId, homeworkId } = Route.useParams();
  return (
    <StudentHomeworkDetailPage
      classroomId={classroomId}
      studentId={studentId}
      homeworkId={homeworkId}
    />
  );
}
